import {Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box} from '@mui/material'
import {Button} from '@origamirisk/origami-storybook'

interface ConfirmationModalProps {
    open: boolean
    title: string
    message: string
    confirmText?: string
    cancelText?: string
    confirmColor?: 'primary' | 'secondary' | 'danger'
    onConfirm: () => void
    onCancel: () => void
}

function ConfirmationModal({
    open,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmColor = 'primary',
    onConfirm,
    onCancel
}: ConfirmationModalProps) {
    const getButtonStyle = () => {
        switch (confirmColor) {
            case 'danger':
                return {backgroundColor: '#d32f2f', color: 'white'}
            case 'secondary':
                return {backgroundColor: '#43a047', color: 'white'}
            default:
                return {}
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            sx={{
                zIndex: 9999
            }}
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                }
            }}
        >
            <DialogTitle sx={{
                fontWeight: 600,
                fontSize: '18px',
                pb: 1
            }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography sx={{color: '#666', fontSize: '14px'}}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{p: 2, pt: 0}}>
                <Button
                    variant="outlined"
                    size="md"
                    onClick={onCancel}
                >
                    {cancelText}
                </Button>
                <Button
                    variant="contained"
                    size="md"
                    onClick={onConfirm}
                    style={getButtonStyle()}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationModal
